import { css } from 'lit';
export const typography = css `
  .headline-1 {
    font-size: 26px;
    line-height: 32px;
    color: var(--type-color-default);
    padding-bottom: var(--spacing-xxl);
    font-weight: 700;
  }

  .headline-2 {
    font-size: 20px;
    line-height: 24px;
    color: var(--type-color-default);
    padding-bottom: var(--spacing-l);
    font-weight: 700;
  }

  .headline-3 {
    font-size: 16px;
    line-height: 20px;
    color: var(--type-color-default);
    padding-bottom: var(--spacing-m);
    font-weight: 700;
  }

  .headline-4 {
    font-size: 10px;
    line-height: 16px;
    color: var(--type-color-default);
    padding-bottom: var(--spacing-s);
    font-weight: 700;
  }

  .headline-5 {
    font-size: 10px;
    line-height: 10px;
    color: var(--type-color-default);
    padding-bottom: var(--spacing-s);
    font-weight: 700;
  }

  .headline-6 {
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 10px;
    color: var(--type-color-default);
    padding-bottom: var(--spacing-s);
  }

  .body-text {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    color: var(--type-color-default);
    padding-bottom: var(--spacing-s);
  }

  .body-text-strong {
    font-size: 16px;
    line-height: 20px;
    font-weight: bold;
    color: var(--type-color-default);
    padding-bottom: var(--spacing-s);
    font-weight: 700;
  }

  .body-text-small {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: var(--type-color-default);
  }
`;
export default typography;
